<div id="user-settings-sessions" class="settings-panel" [class.mobile]="isMobile">
  <div class="head">
    <span class="material-icons go-back" (click)="goBack.emit()"> arrow_back </span>
    <div class="description">
      <div class="title">{{ panelData?.name }}</div>
      <div class="subtitle">{{ panelData?.description }}</div>
    </div>
    <span class="material-icons close" (click)="goBack.emit()"> close </span>
  </div>
  <div class="sub-head" *ngIf="isMobile">
    {{ panelData?.description }}
  </div>
  <form [formGroup]="settingsForm" (submit)="submitChanges()">
    <div class="body">
      <div class="sessions-access-section">
        <div class="sessions-access-title">{{ 'Sessions Access' | translate }}</div>
        <div class="action-bars">
          <div class="bar">
            <app-user-settings-permissions-toggle
              [formGroup]="form"
              [options]="{
                setting: 'crEnablePublicRecordings',
                titleText: ('Allow sessions to be made public' | translate),
                activeText:
                  ('Let hosts share session recordings, summary, and transcript, publicly. Only hosts can change a session\'s access to public.'
                  | translate),
                inactiveText:
                  ('Sessions can only be accessed by their admins, hosts, and participants.'
                  | translate)
              }"
            >
            </app-user-settings-permissions-toggle>
          </div>
        </div>
      </div>
    </div>
    <div class="foot" *ngIf="viewModel$ | async as vm" [class.show]="vm.formChanged">
      <app-pencil-button
        class="pencil-button primary btn-ok"
        [buttonType]="'submit'"
        [class.disabled]="form.invalid"
        [disabled]="form.invalid"
      >
        <span *ngIf="!vm.isLoading" class="material-icons">check</span>
        <mat-spinner *ngIf="vm.isLoading" [diameter]="24"></mat-spinner>
        <span>{{ 'Update' | translate }}</span>
      </app-pencil-button>
      <app-pencil-button
        class="pencil-button light btn-cancel"
        [buttonType]="'button'"
        (clickEvent)="cancelChanges()"
        type="button"
        icon="close"
        [iconConfig]="{ type: 'material-icon' }"
        [label]="'Cancel' | translate"
      >
      </app-pencil-button>
    </div>
  </form>
</div>
